import { render } from "./RFQ.vue?vue&type=template&id=56418c8a"
import script from "./RFQ.vue?vue&type=script&lang=js"
export * from "./RFQ.vue?vue&type=script&lang=js"
script.render = render

export default script